'use strict';
import React, { PureComponent } from 'react';
import CuentasContablesRegistrosBuscador from './CuentasContablesRegistrosBuscador';


class BuscadorCuentasContables extends PureComponent {
    constructor(props) {
        super(props);

        this.limpiarBusqueda = this.limpiarBusqueda.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.buscarCuentasContables = this.buscarCuentasContables.bind(this);
        this.cambiarInputActivo = this.cambiarInputActivo.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    cambiarInputActivo() {
        this.props.cambiarInputActivo(this.props.seccionInput, this.props.nroRenglon);
    }

    buscarCuentasContables(event) {
        let valorInput = event.target.value;

        this.props.cambiarValorInput(valorInput);
        this.props.buscarCuentasContables(valorInput);

    }

    limpiarBusqueda() {
        this.props.cambiarValorInput("");
        this.props.buscarCuentasContables("");
        this.props.cambiarInputActivo(this.props.seccionInput, "");
        this.props.onValorReferenciaChange(this.props.nroRenglon, "0")
        this.props.guardarValorInput("", "")  
    }

    onKeyPress(event) {
        let regExp = /[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ \s]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    onKeyDown(event) {
        event.preventDefault();
        return false;
    }

    render() {
        const {
            contenedorInputBuscador,
            cuentasContables,
            estaHabilitado,
            estiloPlaceholder,
            inputActivo,
            inputClassValorSeleccionado,
            nombreInput,
            esHaber,
            cambiarValorInput,
            seccionInput,
            valorInput,
            nroRenglon            
        } = this.props;

        //ACTIONS
        const {
            cambiarInputActivo,
            guardarValorInput,
            onValorReferenciaChange
        } = this.props;

        let arrayCuentas = [];

        cuentasContables && cuentasContables.map(cuenta => {
            arrayCuentas.push(<CuentasContablesRegistrosBuscador
                                    cambiarInputActivo={cambiarInputActivo}
                                    cuenta={cuenta}
                                    guardarValorInput={guardarValorInput}
                                    cambiarValorInput={cambiarValorInput}
                                    nroRenglon={nroRenglon}
                                    onValorReferenciaChange={onValorReferenciaChange}
                                    key={nombreInput + cuenta.Codigo}
                                    nombreInput={nombreInput}
                                    seccionInput={seccionInput}
                              />);
        });

        arrayCuentas = arrayCuentas.length == 0 ? 
                                <div className="ABMModelos__opcionBuscadorCuentasContablesSinResultados">No se encontraron resultados</div>
                            : 
                                arrayCuentas;


        let claseContenedorInputBuscador = contenedorInputBuscador ? contenedorInputBuscador : "";

        let estiloBotonBorrarBusqueda = esHaber ? " AsientosContables__marginBotonBorrarBusquedaHaberActivo" : ""

        return (
            <div>
                <div className="col-md-12 seccionSuperior__buscador ABMModelosModalContainer__buscadorMargen">
                    {!inputClassValorSeleccionado ?
                        <div className={"AsientosContables--floatLeft seccionSuperior__iconoLupa AsientosContables__iconoLupaInput" + (estaHabilitado ? "" : " seccionSuperior__iconoLupaDeshabilitado")}></div>
                    :
                        null
                    }

                    <div className={"AsientosContables--floatLeft " + claseContenedorInputBuscador}>
                        <input
                            className={"textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs seccionSuperior__inputBuscador AsientosContablesContainer__buscadorAncho" + inputClassValorSeleccionado + (!estaHabilitado ? estiloPlaceholder : "")}
                            disabled={!estaHabilitado}
                            id={nombreInput}
                            name={nombreInput}
                            onChange={this.buscarCuentasContables}
                            onClick={inputClassValorSeleccionado ? null : this.cambiarInputActivo}
                            onFocus={null}
                            onKeyDown={inputClassValorSeleccionado ? this.onKeyDown : null}
                            onKeyPress={this.onKeyPress}
                            placeholder="Buscar por descripción o código"
                            readOnly={inputClassValorSeleccionado}
                            value={valorInput}
                        />
                    </div>


                    {valorInput && valorInput.length > 0 ?
                        <div className="seccionSuperior__botonBuscador AsientosContables__buscadorBotonBorrarBusqueda">
                            <button type="button" className={"btn-tag AsientosContables__buscadorCuentasContables_botonBorrarBusqueda" + estiloBotonBorrarBusqueda}
                                onClick={this.limpiarBusqueda}>
                                <span className="ti-close span-closable" />
                            </button>
                        </div>
                    :
                        null
                    }
                </div>

                <div className={"modalLogIntentosScroll ABMModelos__ContenedorOpcionesBuscadorCuentasContables slider-tarjetas" + (inputActivo ? "" : " closed") }>
                    {arrayCuentas}
                </div>
            </div>
        );
    }
}

export default BuscadorCuentasContables;